import React from 'react';
import styled from 'styled-components';
import { Close } from '@material-ui/icons';

const Wrapper = styled.div`
  width: 11.5rem;
  height: 11.5rem;
  border-radius: 50%;
  margin: auto;
  overflow: hidden;
`;
const DeleteImage = styled.div`
  top: 0;
  right: 0;
  width: 40px;
  color: red;
  position: absolute;
  z-index: 99999;
  height: 40px;
  display: flex;
  align-items: center;
  :hover div {
    visibility: visible;
  }
  cursor: pointer;
`;

const Tooltip = styled.div`
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  right: 0;
  z-index: 99999;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  text-align: center;
  object-fit: cover;
`;
const CloseBt = styled(Close)`
  margin: auto;
`;

const Logo = ({ image, trigerRemoveImage, showDeleteBtn }) => (
  <Wrapper>
    <Image src={image} alt="logo" />
    {showDeleteBtn && (
      <DeleteImage>
        <CloseBt />
        <Tooltip onClick={trigerRemoveImage}>Remove image</Tooltip>
      </DeleteImage>
    )}
  </Wrapper>
);

export default Logo;
